import React, { useState } from 'react';
import Alert from '../../common/Alert';
import Loader from '../../Loader';

import { UploadService } from './../../../service/upload.service';

const UpdateEmails = (params) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [errorMessages, setErrorMessages] = useState([]);

    const [isAlert, setIsAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [pageLoading, setPageLoading] = useState(false);

    const uploadService = new UploadService();

    const onFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const onFileUpload = async () => {
        setPageLoading(true);

        const formData = new FormData();
        formData.append(
            "myFile",
            selectedFile,
            selectedFile.name
        );

        console.log(selectedFile);
        const response = await uploadService.uploadFile(formData);
        if (response.status === 200) {
            const data = response.data.object;
            if (data) {
                setErrorMessages(data);
            }

            if (response.data.isSuccess === true) {
                setAlertMessage("Email(s) updated by this excel file");
            }
            else {
                setAlertMessage("Something wrong, please try again");
            }
        }
        else {
            setAlertMessage("Something wrong, please try again");
        }

        alertOn();
        setPageLoading(false);
    };

    const downloadSampleFile = async () => {
        const result = await uploadService.getDownloadSamplePath();
        if (result.status === 200) {
            window.open(result.data.message, null);
        }
    };

    const alertOff = () => {
        setIsAlert(false);
    };

    const alertOn = () => {
        setIsAlert(true);
    };

    return (
        <>
            {isAlert && <div><Alert type="error" message={alertMessage} callBack={alertOff} /></div>}
            {pageLoading && <Loader />}

            <div className="card" style={{ minWidth: "450px", margin: "auto" }}>
                <h5 className="card-header py-3">
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i> User email updater
                </h5>
                <div className="card-body">
                    <div className="ag-theme-alpine" style={{ maxHeight: "400px", overflowY: "auto" }}>
                        <div style={{ marginTop: "15px" }}>
                            <div>[To update user email from excel, please follow the sample excel file]</div>
                            <div style={{ marginTop: "20px" }}>
                                <input onChange={(e) => onFileChange(e)} style={{ width: "100%" }} className="btn btn-outline-secondary" id="myInput" type="file" name="image" accept=".xlsx, .xls" />
                            </div>
                        </div>
                        <div style={{ marginTop: "20px" }}>
                            {(errorMessages && errorMessages.length > 0) ?
                                <table className="table table-striped" style={{ border: "1px solid #dee2e6" }} >
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Email</th>
                                            <th>NewEmail</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {errorMessages.map(c =>
                                            <tr key={c.email}>
                                                <td>{c.email}</td>
                                                <td>{c.newEmail}</td>
                                                <td>{c.description}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                : ""}
                        </div>
                    </div>
                </div>
                <div className="card-footer text-muted">
                    <div style={{ textAlign: "center" }}>
                        <button className="btn btn-secondary" onClick={onFileUpload}><span><i className="fas fa fa-upload mr-1" ></i></span>Upload & process the excel file</button>
                        <button style={{ marginLeft: "10px" }} onClick={downloadSampleFile} className="btn btn-secondary"><span><i class="far fa fa-download mr-1" ></i></span>Download sample excel</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UpdateEmails;